import React from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from '../../lib/AuthContext';

export const DemoChip = ({ label, children }) => {
  const { isDemo } = useAuth();
  if (!isDemo) return children;

  return (
    <span
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gold-bright/10 border border-gold-bright/30 text-gold-bright text-sm"
      data-testid="demo-chip"
    >
      <Lock className="w-3.5 h-3.5" />
      {label || 'Sign in with Google to use this feature'}
    </span>
  );
};
